import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para que el siguiente renderizado muestre la UI alternativa
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // También puedes registrar el error en un servicio de reporte de errores
    console.error("Error en componente:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // Puedes renderizar cualquier UI alternativa
      return (
        <div style={{
          padding: '20px',
          margin: '40px auto',
          maxWidth: '500px',
          textAlign: 'center',
          backgroundColor: '#25262B',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
        }}>
          <h1 style={{ color: '#C1C2C5' }}>Algo salió mal.</h1>
          <p style={{ color: '#909296' }}>
            Ha ocurrido un error inesperado. Por favor, intenta recargar la página.
          </p>
          {this.state.error && (
            <details style={{ 
              marginTop: '20px', 
              padding: '10px', 
              backgroundColor: '#1A1B1E',
              borderRadius: '4px',
              color: '#909296',
              textAlign: 'left'
            }}>
              <summary>Detalles del error</summary>
              <p>{this.state.error.toString()}</p>
              <p>
                {this.state.errorInfo.componentStack}
              </p>
            </details>
          )}
          <button 
            onClick={() => window.location.href = '/'}
            style={{
              marginTop: '20px',
              backgroundColor: '#EF4444',
              color: 'white',
              border: 'none',
              padding: '10px 20px',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Volver al Inicio
          </button>
        </div>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary; 